import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import {
  PayoutAccountForm,
  PayoutAccountModal,
} from "./FacilityOverviewPagePayoutAccountModal";
import { createApiService } from "./shared/apiConfig";
import { MonitorFacilityApiApi } from "./shared/api/axios-client";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

interface SetupAccountModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  facilityId: number;
  facilityName: string;
}

export default function SetupAccountModal({
  show,
  setShow,
  facilityId,
  facilityName
}: SetupAccountModalProps) {
  const [showPayoutModal, setShowPayoutModal] = useState(false);
  const facilityApi = createApiService(MonitorFacilityApiApi);
  const nav = useNavigate();

  const onSave = async (data: PayoutAccountForm) => {
    try {
      await facilityApi.facilityPayoutAccountUpdate({
        serverTransferMonitorFacilityPayoutAccountUpdateReq: {
          payoutAccount: data.payoutAccountId,
          facilityId: facilityId,
        },
      });

    } catch (err) {
      toast.error("Failed to save payout account");
    }
  };

  return (
    <>
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Set up Bank Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Would you like to set up your payout bank account information now?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShow(false);
              nav("/operator/facilities");
            }}
          >
            Not now
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              setShow(false);
              setShowPayoutModal(true);
            }}
          >
            Yes, set up now
          </Button>
        </Modal.Footer>
      </Modal>

      <PayoutAccountModal
        show={showPayoutModal}
        setShow={setShowPayoutModal}
        facilityId={facilityId}
        selectedPayoutAccount={undefined}
        onSave={onSave}
        isNewFacility={true}
        facilityName={facilityName}
      />
    </>
  );
}
